import React, {useState} from 'react'
import Projects from '../components/projects/components/Projects'
import { Container, Typography } from '@mui/material'
import TopGainersAndLosers from '../components/topGainersAndLosers/components/TopGainersAndLosers'
import Earnings from '../components/earnings/components/Earnings'
import OnboardingUserWindow from '../components/onboarding-user/components/OnboardingUserWindow'
import useUser from '../hooks/useUser'
import WallstreetbetsMentions from '../components/wallstreetbets/components/WallstreetbetsMentions'
import { OnBoardingFormProvider } from '../components/onboarding-user/context/OnboardingUser'
import DashboadGreeting from '../components/dashboardComponents/components/DashboadGreeting'
import Feed from '../components/dashboardComponents/components/Feed'
import styles from './Dashboard.module.scss'

export default function Dashboard() {
    const [openNewUserWindow, setOpenNewUserWindow] = useState(true)
    const {onBoardingFormFilled, user} = useUser()

    return (
        <>
            <DashboadGreeting user={user}/>
            <Container maxWidth="xl" className={styles['big-container']}>
                <section className={styles['container']}>
                    <section className={styles['feed-container']}>
                        <Feed/>
                    </section>
                    <section className={styles['right-container']}>
                        <section>
                            <Typography variant='h3'>
                                Recent Stock Search
                            </Typography>
                            <Projects variant="recent"/>
                        </section>
                        <section className={styles['earning-calendar']}>
                            <Earnings/>
                        </section>
                        <TopGainersAndLosers/>
                        {/* <WallstreetbetsMentions/> */}
                    </section>
                </section>
                {/* OnBoarding Form for new users */}
                {/* <OnBoardingFormProvider>
                    {!onBoardingFormFilled && openNewUserWindow && <OnboardingUserWindow setOpenNewUserWindow={setOpenNewUserWindow}/>}
                </OnBoardingFormProvider> */}
            </Container> 
        </>
    )
}
